// extracted by mini-css-extract-plugin
export default {"calendar":"commessa_calendar__sE6hn","tableOrdini":"commessa_tableOrdini__O5xLu","progressBar":"commessa_progressBar__2QD6x"};